import { useEffect, useState } from "react";
import { getApi, postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const useReligiousBooks = () => {
  const [religiousBooks, setReligiousBooks] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);

  const getReligiousBooks = async () => {
    const body = {
      category: selectedCategories,
      languages: selectedLanguages,
    };
    const response = await postApi(apiEndPoints.allReligiousBooks, body);
    if (response && response.status === 200) {
      setReligiousBooks(response?.data);
    }
  };

  const getBooksLanguages = async () => {
    const res = await getApi(apiEndPoints.getAllbooksLanguages);
    const data = res?.data?.data.map((item) => item.name);
    setLanguages(data);
  };

  const getBooksCategory = async () => {
    const res = await getApi(apiEndPoints.getAllbooksCategory);
    const data = res?.data?.data.map((item) => item.name);
    setCategories(data);
  };

  useEffect(() => {
    getReligiousBooks();
    getBooksLanguages();
    getBooksCategory();
  }, []);

  return {
    religiousBooks,
    selectedCategories,
    setSelectedCategories,
    selectedLanguages,
    setSelectedLanguages,
    languages,
    categories,
    getReligiousBooks,
  };
};

export default useReligiousBooks;
